import $$ from 'jquery'
import FF from '@/common/FF'

// The loader is injected with BOTH `async` and `defer`. `async` wins, so this
// script can execute while the document is still parsing — i.e. before the form
// exists. FF.init() queries the DOM for fields, so running it at import time is
// a race: it happened to win locally and lose on live, where the uploader input
// simply was not in the DOM yet and the widget silently never mounted.
//
// Waiting for DOM ready removes the race in both directions. If the document has
// already finished parsing (the `defer` path, or a late-arriving async script)
// jQuery fires the handler immediately, so nothing is delayed unnecessarily.
$$(function () {
    FF.init()
})
